import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/person-attribute-type";

export const getAllPersonAttributeType = () => axios.get(API_PATH + "/get-all");

export const pagingPersonAttributeType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getPersonAttributeTypeById = (personAttributeTypeId) => axios.get(API_PATH + "/getbyid/" + personAttributeTypeId);

export const saveOrUpdatePersonAttributeType = serviceType => axios.post(API_PATH + "/save-or-update", serviceType);

export const deletePersonAttributeType = personAttributeTypeId => axios.delete(API_PATH + '/mark-delete/' + personAttributeTypeId);
